import * as React from 'react';
import { useState,useEffect } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { Link, useLocation } from 'react-router-dom';
import { Public } from '@mui/icons-material';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import MgpStore from 'Stores/Store';
import MembAccnDtlInfoInqApi from 'Apis/MembAccnDtlInfoInqApi';
import { useDispatch, useSelector } from 'react-redux';
import "Assets/css/MyPage.css";
import { IdntMthdCdStateChng ,AppDispatch} from "Stores/IdntMthdCdReducer";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
//   backgroundColor: 'rgba(0, 0, 0, .03)',
//   flexDirection: 'row-reverse',
//   '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
//     transform: 'rotate(90deg)',
//   },
//   '& .MuiAccordionSummary-content': {
//     marginLeft: theme.spacing(1),
//   },
//   ...theme.applyStyles('dark', {
//     backgroundColor: 'rgba(255, 255, 255, .05)',
//   }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function CustomizedAccordions() {
  const [expanded, setExpanded] = React.useState<string | false>('');
  const [isMobileCategoryOpen, setIsMobileCategoryOpen] = useState(false);
  const [mobileMenuTitle, setMobileMenuTitle] = useState<string>("");
  const {isLoading,error,data: langData}:any = UseLangLstQuery();
  const dispatch = useDispatch<AppDispatch>();
  const reduxIdntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
  const [membAccnDtlInfo,setMembAccnDtlInfo] = useState<any>();
  const location = useLocation();
  const currentIdntMthdCd = reduxIdntMthdCd || membAccnDtlInfo?.idntMthdCd;
  useEffect(()=>{
      MembAccnDtlInfoInqApi()
      .then((resp) => {
          setMembAccnDtlInfo(resp.apiBody);
          dispatch(IdntMthdCdStateChng(resp.apiBody.idntMthdCd));  
      });

      // 닉네임 변경 이벤트 리스너 등록
      const handleNicknameChange = (event: any) => {
          setMembAccnDtlInfo((prevInfo: any) => ({
              ...prevInfo,
              nickname: event.detail.newNickname
          }));
      };

      window.addEventListener('nicknameChanged', handleNicknameChange);

      // 클린업 함수로 이벤트 리스너 제거
      return () => {
          window.removeEventListener('nicknameChanged', handleNicknameChange);
      };
  },[]);

  // 현재 경로에 따라 expanded 상태 설정
  useEffect(() => {
    const lowerPath = location.pathname.toLowerCase();
    
    if (lowerPath.startsWith('/mypage/gamesvcrel')) {
      setExpanded('panel2');
    } else if (lowerPath.startsWith('/mypage/gamesvcmny') || 
               lowerPath.startsWith('/mypage/gamesvcitem') || 
               lowerPath.startsWith('/mypage/gamesvcgift')) {
      setExpanded('panel3');
    } else if (lowerPath.startsWith('/mypage/ntfymsg')) {
      setExpanded('panel4');
    } else if (lowerPath.startsWith('/mypage/qna')) {
      setExpanded('panel5');
    } else if (lowerPath.startsWith('/mypage') && 
               !lowerPath.includes('/gamesvc') && 
               !lowerPath.includes('/ntfymsg') && 
               !lowerPath.includes('/qna')) {
      setExpanded('panel1');
    } else {
      setExpanded(false);
    }
  }, [location.pathname]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  // 현재 경로에 따라 active 클래스를 결정하는 함수
  const isActiveMenu = (menuPath: string) => {
    return location.pathname === menuPath || location.pathname.startsWith(menuPath);
  };

  // 현재 페이지 타이틀 반환
  const getCurrentPageTitle = () => {
    if (mobileMenuTitle) return mobileMenuTitle;
    const path = location.pathname.toLowerCase();
    if (path.startsWith('/mypage/gamesvcrel')) return langData?.MYPAGE_MENU_GAME_REL_BTN_00 || '게임 연동';
    if (path.startsWith('/mypage/gamesvcmny') || path.startsWith('/mypage/gamesvcitem') || path.startsWith('/mypage/gamesvcgift')) return langData?.MYPAGE_MENU_MNY_LST_BTN_00 || '캐시/아이템';
    if (path.startsWith('/mypage/ntfymsg')) return langData?.MYPAGE_MENU_NTFY_MSG_BTN_00 || '알림';
    if (path.startsWith('/mypage/qna')) return langData?.MYPAGE_MAIN_CTGR_QNA_BTN_00 || '문의';
    if (path.startsWith('/mypage') && !path.includes('/gamesvc') && !path.includes('/ntfymsg') && !path.includes('/qna')) return langData?.MYPAGE_MENU_MEMB_INFO_BTN_00 || '내 정보';
    return langData?.MYPAGE_MENU_MEMB_INFO_BTN_00 || '메뉴';
  };

  // 모바일 메뉴 오버레이 body 스크롤 제어
  useEffect(() => {
    if (isMobileCategoryOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileCategoryOpen]);

  return (
    <div className='mypageAccordionMenuWrap'>
      <div className='myPage usrInfo'>
        <Link to={'/MyPage'}>
          <h1>My Page</h1>
          <div className='nicknameWrap'>
            <img src={process.env.PUBLIC_URL + "/images/Mypage/mypageicon.png"} alt="" />
            <div>
              <p   className='nicknameText'>{membAccnDtlInfo?.nickname}</p>
              {/* <p   className='idText'>({membAccnDtlInfo?.membRcmnCd})</p> */}
            </div>
          </div>
        </Link>
      </div>
      {/* 모바일 메뉴 버튼 */}
      <button
        className="mobileCategoryBtn"
        onClick={() => setIsMobileCategoryOpen(!isMobileCategoryOpen)}
      >
        <span>{getCurrentPageTitle()}</span>
        <span className={`category-arrow ${isMobileCategoryOpen ? 'up' : 'down'}`}></span>
      </button>

      {/* 모바일 메뉴 오버레이 */}
      {isMobileCategoryOpen && (
        <div className="mobileMenuOverlay" onClick={() => setIsMobileCategoryOpen(false)} />
      )}

      {/* 모바일 메뉴 본문 (아코디언 전체 감싸기) */}
      <div className={`faqCtgrLstWrap${isMobileCategoryOpen ? ' mobileOpen' : ''}`}>
        {/* 기존 아코디언 메뉴 전체 */}
        {membAccnDtlInfo && currentIdntMthdCd !== "NA" && (
         <Accordion  className={`mypageAccordionMenu ${isActiveMenu('/MyPage') && !location.pathname.includes('/GameSvc') && !location.pathname.includes('/NtfyMsg') ? 'active' : ''}`} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
            <Link to={'/MyPage'} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00); }}>
              <AccordionSummary className={"mypageAccordionSummary"} aria-controls="panel1d-content" id="panel1d-header">
                <Typography className={"mypageAccordionTitl"}>
                      <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00); }}>{langData&&langData.MYPAGE_MENU_MEMB_INFO_BTN_00}</p>
                </Typography>
              </AccordionSummary>
            </Link>
            <AccordionDetails  className={"mypageAccordionDetails"}>
              <Typography>
                <ul className='mypageSubMenuUl'>
                    <li>
                        <Link to={"/MyPage/passwdchng"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00); }}>
                          <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00); }}>{langData&&langData.MYPAGE_MENU_PASSWD_CHNG_BTN_00}</p>
                        </Link>
                    </li>
                      {currentIdntMthdCd !== "MBP" ?
                        <li>
                              <Link to={"/MyPage/IdntMthdChng"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_ATHN_CHNG_BTN_00); }}>
                                <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_ATHN_CHNG_BTN_00); }}>{langData&&langData.MYPAGE_MENU_ATHN_CHNG_BTN_00}</p>
                              </Link>
                        </li>
                        :
                        <li>
                              <Link to={"/MyPage/IdntMthdReAthn"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_BTN_00); }}>
                                <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_BTN_00); }}>{langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_BTN_00}</p>
                              </Link>
                        </li>

                      }
                    <li>
                      <Link to={"/MyPage/EmlChng"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_EML_CHNG_BTN_00); }}>
                        <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_EML_CHNG_BTN_00); }}>{langData&&langData.MYPAGE_MAIN_EML_CHNG_BTN_00}</p>
                      </Link>
                    </li>
                    <li>
                      <Link to={"/MyPage/OtpReg"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00); }}>
                        <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00); }}>{langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00}</p>
                      </Link>
                    </li>
                    <li>
                      <Link to={"/MyPage/MembLvd"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MEMB_LVD_BTN_00); }}>
                        <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MEMB_LVD_BTN_00); }}>{langData&&langData.MYPAGE_MENU_MEMB_LVD_BTN_00}</p>
                      </Link>
                    </li>
                </ul>
              </Typography>
            </AccordionDetails>
          </Accordion>
         )}
        {/* {membAccnDtlInfo && membAccnDtlInfo.idntMthdCd !== "NA" && (
           <Accordion className={`mypageAccordionMenu ${isActiveMenu('/MyPage/GameSvcRelLst') ? 'active' : ''}`} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
            <Link to={'/MyPage/GameSvcRelLst'}>
              <AccordionSummary className={"mypageAccordionSummary"} aria-controls="panel2d-content" id="panel2d-header">
                  <Typography className={"mypageAccordionTitl mypageAccordionTitlLink"}>
                    <p>{langData&&langData.MYPAGE_MENU_GAME_REL_BTN_00}</p>
                  </Typography>
              </AccordionSummary>
            </Link>
          </Accordion>
         )} */}
        {membAccnDtlInfo && currentIdntMthdCd !== "NA" && (
         <Accordion className={`mypageAccordionMenu ${isActiveMenu('/MyPage/GameSvcMny') ? 'active' : ''}`} expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
              <Link to={"/MyPage/GameSvcMnyDpstLst"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00); }}>
              <AccordionSummary className={"mypageAccordionSummary"} aria-controls="panel3d-content" id="panel3d-header">
                <Typography className={"mypageAccordionTitl mypageAccordionTitlLink"}>
                    <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00); }}>{langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00}</p>
                </Typography>
              </AccordionSummary>
            </Link>
          </Accordion>
         )}
          <Accordion  className={`mypageAccordionMenu ${isActiveMenu('/MyPage/NtfyMsg') ? 'active' : ''}`} expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
            <Link to={"/MyPage/NtfyMsgLst"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_NTFY_MSG_BTN_00); }}>
              <AccordionSummary className={"mypageAccordionSummary"} aria-controls="panel1d-content" id="panel1d-header">
                <Typography className={"mypageAccordionTitl mypageAccordionTitlLink"}>
                      <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MENU_NTFY_MSG_BTN_00); }}>{langData&&langData.MYPAGE_MENU_NTFY_MSG_BTN_00}</p>
                </Typography>
              </AccordionSummary>
            </Link>
          </Accordion>
          <Accordion  className={`mypageAccordionMenu ${isActiveMenu('/MyPage/Qna') ? 'active' : ''}`} expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
            <Link to={'/MyPage/QnaLst'} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_CTGR_QNA_BTN_00); }}>
              <AccordionSummary className={"mypageAccordionSummary"} aria-controls="panel5d-content" id="panel5d-header">
                <Typography className={"mypageAccordionTitl"}>
                      <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_CTGR_QNA_BTN_00); }}>{langData&&langData.MYPAGE_MAIN_CTGR_QNA_BTN_00}</p>
                </Typography>
              </AccordionSummary>
            </Link>
            <AccordionDetails  className={"mypageAccordionDetails"}>
              <Typography>
                <ul className='mypageSubMenuUl'>
                    <li>
                      <Link to={"/MyPage/QnaLst"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00); }}>
                        <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00); }}>{langData&&langData.MYPAGE_MAIN_QNA_LST_BTN_00}</p>
                      </Link>
                    </li>
                    <li>
                      <Link to={"/MyPage/QnaWrite"} onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_QNA_REG_BTN_00); }}>
                        <p onClick={() => { setIsMobileCategoryOpen(false); setMobileMenuTitle(langData&&langData.MYPAGE_MAIN_QNA_REG_BTN_00); }}>{langData&&langData.MYPAGE_MAIN_QNA_REG_BTN_00}</p>
                      </Link>
                    </li>
                </ul>
              </Typography>
            </AccordionDetails>
          </Accordion>
      </div>
    </div>
  );
}